var _a;
import { __assign } from "tslib";
import { createTheme } from '@mui/material/styles';
var styles = {
    fontSize: {
        title: '18px',
        subtitle: '18px',
        body1: '16px',
        body2: '14px',
        button: '15px',
        caption: '12px',
        overline: '12px',
        'input-label': '12px',
        'input-text': '16px',
        'helper-text': '12px',
        tooltip: '13px',
        h1: '96px',
        h2: '60px',
        h3: '48px',
        h4: '34px',
        h5: '24px',
        h6: '20px',
    },
    letterSpacing: {
        title: '.15px',
        subtitle: '.15px',
        body1: '.15px',
        body2: '.17px',
        button: '.46px',
        caption: '.4px',
        overline: '1px',
        'input-label': '.15px',
        'input-text': '.4px',
        'helper-text': '.15px',
        tooltip: '0px',
        h1: '-1.5px',
        h2: '-.5px',
        h3: '0px',
        h4: '.25px',
        h5: '0px',
        h6: '.15px',
    },
    fontWeight: {
        title: 700,
        subtitle: 400,
        body1: 400,
        body2: 400,
        button: 700,
        caption: 400,
        overline: 400,
        'input-label': 400,
        'input-text': 400,
        'helper-text': 400,
        tooltip: 700,
        h1: 400,
        h2: 400,
        h3: 400,
        h4: 400,
        h5: 400,
        h6: 700,
    },
};
/** @todo remove 'important' after remove global styles */
var themeBase = createTheme({
    typography: {
        fontFamily: "'sohne', Fallback, sans-serif",
        h1: {
            fontSize: "".concat(styles.fontSize.h1, " !important"),
            fontWeight: styles.fontWeight.h1,
            letterSpacing: styles.letterSpacing.h1,
        },
        h2: {
            fontSize: "".concat(styles.fontSize.h2, " !important"),
            fontWeight: styles.fontWeight.h2,
            letterSpacing: styles.letterSpacing.h2,
        },
        h3: {
            fontSize: "".concat(styles.fontSize.h3, " !important"),
            fontWeight: styles.fontWeight.h3,
            letterSpacing: styles.letterSpacing.h3,
        },
        h4: {
            fontSize: "".concat(styles.fontSize.h4, " !important"),
            fontWeight: styles.fontWeight.h4,
            letterSpacing: styles.letterSpacing.h4,
        },
        h5: {
            fontSize: "".concat(styles.fontSize.h5, " !important"),
            fontWeight: styles.fontWeight.h5,
            letterSpacing: styles.letterSpacing.h5,
        },
        h6: {
            fontSize: "".concat(styles.fontSize.h6, " !important"),
            fontWeight: styles.fontWeight.h6,
            letterSpacing: styles.letterSpacing.h6,
        },
        subtitle1: {
            fontSize: "".concat(styles.fontSize.title, " !important"),
            fontWeight: styles.fontWeight.title,
            letterSpacing: styles.letterSpacing.title,
        },
        subtitle2: {
            fontSize: "".concat(styles.fontSize.subtitle, " !important"),
            fontWeight: styles.fontWeight.subtitle,
            letterSpacing: styles.letterSpacing.subtitle,
        },
        body1: {
            fontSize: "".concat(styles.fontSize.body1, " !important"),
            fontWeight: styles.fontWeight.body1,
            letterSpacing: styles.letterSpacing.body1,
        },
        body2: {
            fontSize: "".concat(styles.fontSize.body2, " !important"),
            fontWeight: styles.fontWeight.body2,
            letterSpacing: styles.letterSpacing.body2,
        },
        button: {
            fontSize: "".concat(styles.fontSize.button, " !important"),
            fontWeight: styles.fontWeight.button,
            letterSpacing: styles.letterSpacing.button,
        },
        caption: {
            fontSize: "".concat(styles.fontSize.caption, " !important"),
            fontWeight: styles.fontWeight.caption,
            letterSpacing: styles.letterSpacing.caption,
        },
        overline: {
            fontSize: "".concat(styles.fontSize.overline, " !important"),
            fontWeight: styles.fontWeight.overline,
            letterSpacing: styles.letterSpacing.overline,
        },
    },
});
export var theme = createTheme(themeBase, {
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    h1: 'h2',
                    h2: 'h2',
                    h3: 'h2',
                    h4: 'h2',
                    h5: 'h2',
                    h6: 'h2',
                    subtitle1: 'h2',
                    subtitle2: 'h2',
                    body1: 'span',
                    body2: 'span',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: __assign({}, themeBase.typography.button),
            },
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        borderRadius: '9px',
                        textTransform: 'initial',
                        lineHeight: '27px',
                    },
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        border: '1px solid',
                        borderRadius: '9px',
                        textTransform: 'initial',
                    },
                },
                {
                    props: { variant: 'outlined', color: 'primary' },
                    style: {
                        borderColor: themeBase.palette.primary.main,
                        color: themeBase.palette.primary.main,
                    },
                },
                {
                    props: { variant: 'outlined', color: 'secondary' },
                    style: {
                        borderColor: themeBase.palette.secondary.light,
                        color: themeBase.palette.secondary.main,
                    },
                },
                {
                    props: { size: 'large' },
                    style: {
                        fontSize: styles.fontSize.h5,
                        letterSpacing: styles.letterSpacing.h5,
                        lineHeight: '44px',
                    },
                },
            ],
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '4px',
                    overflow: 'hidden',
                    boxShadow: 'none',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                },
                label: __assign(__assign({}, themeBase.typography.body1), { fontWeight: 'bold', textTransform: 'uppercase' }),
            },
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        borderWidth: '2px',
                        color: themeBase.palette.text.primary,
                    },
                },
            ],
        },
        MuiContainer: {
            styleOverrides: {
                maxWidthXl: (_a = {},
                    _a[themeBase.breakpoints.up('xl')] = {
                        maxWidth: 'calc(100% - 320px)',
                    },
                    _a),
            },
        },
    },
});
